import eng from './eng';
import thai from './thai';

const translations = {
    eng,
    thai
}

export default translations;
